import script from "./AddActivityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddActivityModal.vue?vue&type=script&setup=true&lang=js"

import "./AddActivityModal.vue?vue&type=style&index=0&id=0022c7db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0022c7db"]])

export default __exports__